@if (attachments.length > 0) {
  <ul
    class="spot-list spot-list_compact op-file-list"
    >
    @for (attachment of attachments; track attachment; let i = $index) {
      <li
        op-attachment-list-item
        class="spot-list--item op-file-list--item"
        data-test-selector="op-attachment-list-item"
        [attachment]="attachment"
        [showTimestamp]="showTimestamp"
        [showDelete]="showDelete"
        [index]="i"
        (removeAttachment)="removeAttachment(attachment)"
      ></li>
    }
  </ul>
}
